export default __webpack_public_path__ + "static/media/brt.5a75c34f.svg";